import type { InterfacePageEntity } from '@unifyapps/defs/types/page';
import _keyBy from 'lodash/keyBy';
import { useMemo } from 'react';
import { MODULE_COMPONENT_FILTER } from '../../../../../utils/interfaceQueryFilters';
import { useDeployedInterfaceComponent } from '../useFetchDeployedInterfaceComponent';

function useDeployedInterfaceModules({ interfaceId }: { interfaceId: string }) {
  const {
    interfaceComponents: interfaceModules,
    isLoading,
    error,
  } = useDeployedInterfaceComponent({
    interfaceId,
    searchFilters: MODULE_COMPONENT_FILTER,
  });

  const interfaceModulesMap = useMemo(() => {
    if (!interfaceModules) return {};
    return _keyBy(interfaceModules, 'id') as Record<string, InterfacePageEntity | undefined>;
  }, [interfaceModules]);

  return {
    interfaceModulesMap,
    isLoading,
    error,
  };
}

export { useDeployedInterfaceModules };
